import Translate from '../../../modules/util/Translate'

// コンポーネントの翻訳ファイル
import PdfLinkMessages from '../../../components/PdfLink/language'
import { LocaleMessages } from 'vue-i18n'

const pdfLinks: LocaleMessages = {
  en: {
    PdfDownloadListWithImg: {
      downloadMsg: 'E-mail address registration is required for download.'
    },
    pdfDownloadList: {
      empty: "Sorry, we couldn' find any results matching."
    }
  },
  'zh-hant': {
    PdfDownloadListWithImg: {
      downloadMsg: '下載時請先完成電子信箱註冊。',
      empty: '对不起，没有找到符合您要求的答案'
    }
  },
  ja: {
    PdfDownloadListWithImg: {
      downloadMsg: 'ダウンロードにはメールアドレスの登録が必要です。',
      empty: '一致する結果は見つかりませんでした。'
    }
  },
  es: {
    PdfDownloadListWithImg: {
      downloadMsg:
        'Se requiere el registro de la dirección de correo electrónico para la descarga.'
    }
  },
  'pt-br': {
    PdfDownloadListWithImg: {
      downloadMsg:
        'O registro do endereço de e-mail é necessário para fazer o download.'
    }
  }
}

export default Translate([pdfLinks, PdfLinkMessages])
